import React, { Component } from "react";
import Feature from "../../../components/_common/Feature";

import "./information-articles.scss";

class InformationArticles extends Component {
  render() {
    const { items } = this.props;

    return (
      <div className="information-articles">
        {items &&
          items.map((item, index) => (
            <Feature
              key={`visit-article_${index}`}
              article={item}
              className="feature feature--info"
              bgColor={item.backgroundColor}
              reverse={index % 2 === 0}
              colReverse={true}
              noGutters={true}
              index={index}
            />
          ))}
      </div>
    );
  }
}

export default InformationArticles;



// WEBPACK FOOTER //
// ./src/pages/visitus/InformationArticles/index.js